import React, {useMemo, useState} from "react";
import closeIcon from "../../img/closeIcon.svg";
import radioBtnCheckIcon from "../../img/radioButtonCheckedIcon.svg";
import radioBtnUnCheckIcon from "../../img/radioButtonUnCheckedIcon.svg";
import docImgPage1 from "../../img/bolDocumentPage1.jpeg";
import docImgPage2 from "../../img/bolDocumentPage2.jpeg";
import showMoreBtnIcon from "../../img/moreButtonTable.svg";
import addPlusIcon from "../../img/addPlusBlueIcon.svg";
import rowDownIcon from "../../img/rowDownIcon.svg";
import rowUpIcon from "../../img/rowUpIcon.svg";
import Select from 'react-select';
import {useFormik} from "formik";
import * as Yup from "yup";
import CustomSelect from "../../utils/CustomSelect/CustomSelect";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import useGetListTemplate from "../../utils/CustomHooks/useGetListTemplate/useGetListTemplate";
import NoOptionsClearValue from "../ReusedComponents/NoOptionsClearValue/NoOptionsClearValue";

const CreateDocSetBolModal = (props) => {

    const {
        closeModal,
        activeNoLoadingOrder,
        cargoCaseDocument,
        addBolCargoCase,
        errorMessage,
        editDoc,
        selectedCargoCaseBol
    } = props;

    const { auth, dictionaryPorts } = useAuth();
    const [activeChangePage, setActiveChangePage] = useState('1');
    // const [toggleTemplateBtn, setToggleTemplateBtn] = useState('2');
    const [activeOpenOptional, setActiveOpenOptional] = useState(false);
    const currentCargoCaseBol = useMemo(() => selectedCargoCaseBol,[selectedCargoCaseBol]);
    // const optionsLoadingOrder = [{ value: cargoCaseDocument[0]?.id, label: cargoCaseDocument[0]?.orderNumber}];
    const {isOptionsTemplate} = useGetListTemplate(auth?.user?.organization, 'BOL');
    // const optionsNumberOfOriginals = [{ value: 3, label: 3}];

    const optionGrossWeight = [
        {value: 'KGS'},
        {value: 'SQ_M'},
        {value: 'TN'},
        {value: 'PIECES'},
        {value: 'CBM'}
    ]

    const optionsTemplate = isOptionsTemplate.map(el => ({
        "value": el?.id,
        "label": el?.fileName
    }))

    // const optionPorts = dictionaryPorts.map(el => ({
    //     "value": el?.id,
    //     "label": el?.name
    // }))

    const onHandleClearValue = () => {
        formik.setFieldValue('template_id', undefined)
    }

    const onClearTemplate = () => {
        return (
            <NoOptionsClearValue
                onHandleClearValue={() => onHandleClearValue()}
            />
        )
    }

    const formik = useFormik({
        initialValues: {
            dateOfLoading: editDoc === true ? currentCargoCaseBol[0]?.dateOfLoading : "",
            shipper: cargoCaseDocument[0]?.shipper,
            portOfLoading: cargoCaseDocument[0]?.portOfLoading,
            portOfDischarge: cargoCaseDocument[0]?.portOfDischarge,
            vessel: cargoCaseDocument[0]?.vessel,
            captain_id: cargoCaseDocument[0]?.captain?.id,
            consignee: cargoCaseDocument[0]?.consignee,
            bookingRef: editDoc === true ? currentCargoCaseBol[0]?.bookingRef : "",
            shipowner: cargoCaseDocument[0]?.shipowner,
            descriptionOfGoods: cargoCaseDocument[0]?.numberCertOfOrigin,
            notify: editDoc === true ? currentCargoCaseBol[0]?.notify : "",
            cargoCaseID: cargoCaseDocument[0]?.id,
            bankID: 1,
            grossQuantity: editDoc === true ? currentCargoCaseBol[0]?.grossQuantity : null,
            grossUnitType: editDoc === true ? currentCargoCaseBol[0]?.grossUnitType : "KGS",
            netQuantity: editDoc === true ? currentCargoCaseBol[0]?.netQuantity : null,
            netUnitType: editDoc === true ? currentCargoCaseBol[0]?.netUnitType : "KGS",
            bblsGross: editDoc === true ? currentCargoCaseBol[0]?.bblsGross : null,
            bblsNet: editDoc === true ? currentCargoCaseBol[0]?.bblsNet : null,
            bolRemarks: editDoc === true ? currentCargoCaseBol[0]?.bolRemarks : "",
            template_id: editDoc === true && currentCargoCaseBol[0]?.template !== undefined ? currentCargoCaseBol[0]?.template?.id : '',
            vesselFlag_id: cargoCaseDocument[0]?.vesselFlag?.id,
            notifyParty: editDoc === true ? currentCargoCaseBol[0]?.notifyParty : "",
            unitsOfMeasurement: editDoc === true ? currentCargoCaseBol[0]?.unitsOfMeasurement : "",
            carrier: cargoCaseDocument[0]?.shipowner?.name,
            characterPartyDated: editDoc === true ? currentCargoCaseBol[0]?.characterPartyDated : "",
            referenceNo: editDoc === true ? currentCargoCaseBol[0]?.referenceNo : "",
            codeName: editDoc === true ? currentCargoCaseBol[0]?.codeName : "",
        },
        validationSchema: Yup.object({
            // portOfDischarge: Yup.object()
            //     .required('Required field!'),
            bookingRef: Yup.string()
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!')
                .required('Required field!'),
            dateOfLoading: Yup.date()
                .required('Required field!'),
            // descriptionOfGoods: Yup.string()
            //     .required('Required field!'),
            notify: Yup.string()
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!')
                .required('Required field!'),
            // cargoCaseID: Yup.string()
            //     .required('Required field!'),
            grossQuantity: Yup.string()
                .required('Required field!')
                .matches(/^\d+$/, 'Is not in correct format!'),
            netQuantity: Yup.string()
                .required('Required field!')
                .matches(/^\d+$/, 'Is not in correct format!'),
            bblsGross: Yup.string()
                .required('Required field!')
                .matches(/^\d+$/, 'Is not in correct format!'),
            bblsNet: Yup.string()
                .required('Required field!')
                .matches(/^\d+$/, 'Is not in correct format!'),
            bolRemarks: Yup.string()
                .matches(/(?:\s|^)[\p{L}\p{M}0-9\-._]+(?:\s|$)/u, 'Is not in correct format!')
                .required('Required field!'),
        }),
        onSubmit: values => addBolCargoCase(values, currentCargoCaseBol[0]?.id)
    })

    return (
        <div className="create-doc-set-bol-modal__container">
            <form onSubmit={formik.handleSubmit} className="create-doc-set-bol-modal">
                <div className="create-doc-set-bol-modal__title">
                    <h3>BOL</h3>
                    <img onClick={closeModal} src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="create-doc-set-bol-modal-main-block">
                    <div className="create-doc-set-bol-modal__document-image-page">
                        <img className="create-doc-set-bol-modal__document-img" src={activeChangePage === '1' ? docImgPage1 : docImgPage2} alt={'изображение документа'}/>
                        <div className="create-doc-set-bol-modal__document-page">
                            <div onClick={() => setActiveChangePage('1')} className={activeChangePage === '1' ? "create-doc-set-bol-modal__document-page-number active" : "create-doc-set-bol-modal__document-page-number"}>1</div>
                            <div onClick={() => setActiveChangePage('2')} className={activeChangePage === '2' ? "create-doc-set-bol-modal__document-page-number active" : "create-doc-set-bol-modal__document-page-number"}>2</div>
                        </div>
                    </div>
                    <div className="create-doc-set-bol-modal__templates">
                        <div className="create-doc-set-bol-modal__templates-radio-buttons">
                            <div className="create-doc-set-loading-order-modal__three-inputs-item">
                                <label htmlFor="template_id">Select template</label>
                                <CustomSelect
                                    options={optionsTemplate}
                                    value={formik.values.template_id}
                                    onChange={value => formik.setFieldValue('template_id', value.value)}
                                    noOptionsMessage={() => onClearTemplate(formik.values.template_id)}
                                />
                            </div>
                            {/*<div className="create-doc-set-bol-modal__templates-btn">*/}
                            {/*    <img onClick={() => setToggleTemplateBtn('1')} className={toggleTemplateBtn === '1' ? "create-doc-set-bol-modal__templates-btn-icon active" : "create-doc-set-bol-modal__templates-btn-icon"} src={toggleTemplateBtn === '1' ? radioBtnCheckIcon : radioBtnUnCheckIcon} alt={'радио-кнопка'}/>*/}
                            {/*    <p className="create-doc-set-bol-modal__templates-label">Template 1</p>*/}
                            {/*</div>*/}
                            {/*<div className="create-doc-set-bol-modal__templates-btn">*/}
                            {/*    <img onClick={() => setToggleTemplateBtn('2')}  className={toggleTemplateBtn === '2' ? "create-doc-set-bol-modal__templates-btn-icon active" : "create-doc-set-bol-modal__templates-btn-icon"} src={toggleTemplateBtn === '2' ? radioBtnCheckIcon : radioBtnUnCheckIcon} alt={'радио-кнопка'}/>*/}
                            {/*    <p className="create-doc-set-bol-modal__templates-label">Template 2</p>*/}
                            {/*</div>*/}
                        </div>
                        {activeNoLoadingOrder === false && (
                            <>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Tanker name</label>
                                        <Select placeholder={'CORAL SEA'}/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Vessel</label>
                                        <Select placeholder={'ARIADNI'}/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Capitan</label>
                                        <Select placeholder={'MARTIN SMITH'}/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Flag</label>
                                        <Select placeholder={'LIBERIA'}/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Destination</label>
                                        <input type={'text'} className="create-doc-set-bol-modal__templates-input-text-description"/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Port of loading</label>
                                        <input type={'text'} className="create-doc-set-bol-modal__templates-input-text-description"/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Destination country</label>
                                        <input type={'text'} className="create-doc-set-bol-modal__templates-input-text-description"/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Shipper</label>
                                        <input type={'text'} className="create-doc-set-bol-modal__templates-input-text-description"/>
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                                    <div className="create-doc-set-bol-modal__templates-input">
                                        <label>Consignee</label>
                                        <Select placeholder={'TOTHE ORDER OF'}/>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="create-doc-set-bol-modal__templates-group-inputs">
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Bill of lading number</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"text"}
                                       name={'bookingRef'}
                                       defaultValue={editDoc === true ? currentCargoCaseBol[0]?.bookingRef : formik.values.name}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                />
                                {formik.errors.bookingRef && formik.touched.bookingRef ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.bookingRef}</p> : null}
                            </div>
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Date bill of lading</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"date"}
                                       name={'dateOfLoading'}
                                       defaultValue={editDoc === true ? currentCargoCaseBol[0]?.dateOfLoading : formik.values.name}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                />
                                {formik.errors.dateOfLoading && formik.touched.dateOfLoading ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.dateOfLoading}</p> : null}
                            </div>
                            {/*<div className="create-doc-set-bol-modal__templates-input">*/}
                            {/*    <label htmlFor="cargoCaseID">Loading order number</label>*/}
                            {/*    <CustomSelect*/}
                            {/*        options={optionsLoadingOrder}*/}
                            {/*        value={formik.values.cargoCaseID}*/}
                            {/*        onChange={value => formik.setFieldValue('cargoCaseID', value.value)}*/}
                            {/*    />*/}
                            {/*    {formik.errors.cargoCaseID && formik.touched.cargoCaseID ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.cargoCaseID}</p> : null}*/}
                            {/*</div>*/}
                        </div>
                        <div className="create-doc-set-bol-modal__templates-group-inputs">
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Port of Loading</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"text"}
                                       defaultValue={cargoCaseDocument[0]?.portOfLoadingName}
                                       disabled={true}
                                />
                            </div>
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Port of discharge</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"text"}
                                       defaultValue={cargoCaseDocument[0]?.portOfDischargeName}
                                       disabled={true}
                                />
                            </div>
                        </div>
                        <div className="create-doc-set-bol-modal__templates-group-inputs">
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Description of goods</label>
                                <input className="create-doc-set-bol-modal__templates-input-text-description"
                                       type={"text"}
                                       defaultValue={cargoCaseDocument[0]?.numberCertOfOrigin}
                                       disabled={true}
                                />
                            </div>
                        </div>
                        <div className="create-doc-set-bol-modal__templates-group-inputs">
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Gross quantity (kilos)</label>
                                <div className="create-doc-set-bol-modal__templates-input-gross">
                                    <input className="create-doc-set-bol-modal__templates-input-text-gross"
                                           type={"text"}
                                           name={'grossQuantity'}
                                           defaultValue={editDoc === true ? currentCargoCaseBol[0]?.grossQuantity : formik.values.name}
                                           onChange={formik.handleChange}
                                           onBlur={formik.handleBlur}
                                    />
                                    <select className="create-doc-set-loading-order-modal__select-weight"
                                            name={'grossUnitType'}
                                            defaultValue={editDoc === true ? currentCargoCaseBol[0]?.grossUnitType : formik.values.grossUnitType}
                                            onChange={formik.handleChange}
                                    >
                                        {optionGrossWeight.map((el, i) => {
                                            return (
                                                <option value={el?.value} key={i}>{el?.value}</option>
                                            )
                                        })}
                                    </select>
                                    {formik.errors.grossQuantity && formik.touched.grossQuantity ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.grossQuantity}</p> : null}
                                </div>
                            </div>
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Net quantity</label>
                                <div className="create-doc-set-bol-modal__templates-input-gross">
                                    <input className="create-doc-set-bol-modal__templates-input-text-gross"
                                           type={"text"}
                                           name={'netQuantity'}
                                           defaultValue={editDoc === true ? currentCargoCaseBol[0]?.netQuantity : formik.values.name}
                                           onChange={formik.handleChange}
                                           onBlur={formik.handleBlur}
                                    />
                                    <select className="create-doc-set-loading-order-modal__select-weight"
                                            name={'netUnitType'}
                                            defaultValue={editDoc === true ? currentCargoCaseBol[0]?.netUnitType : formik.values.netUnitType}
                                            onChange={formik.handleChange}
                                    >
                                        {optionGrossWeight.map((el, i) => {
                                            return (
                                                <option value={el?.value} key={i}>{el?.value}</option>
                                            )
                                        })}
                                    </select>
                                    {formik.errors.netQuantity && formik.touched.netQuantity ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.netQuantity}</p> : null}
                                </div>
                            </div>
                        </div>
                        <div className="create-doc-set-bol-modal__templates-group-inputs">
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>BBLS gross</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"text"}
                                       name={'bblsGross'}
                                       defaultValue={editDoc === true ? currentCargoCaseBol[0]?.bblsGross : formik.values.name}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                />
                                {formik.errors.bblsGross && formik.touched.bblsGross ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.bblsGross}</p> : null}
                            </div>
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>BBLS net</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"text"}
                                       name={'bblsNet'}
                                       defaultValue={editDoc === true ? currentCargoCaseBol[0]?.bblsNet : formik.values.name}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                />
                                {formik.errors.bblsNet && formik.touched.bblsNet ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.bblsNet}</p> : null}
                            </div>
                        </div>
                        {/*<div className="create-doc-set-bol-modal-add-new-field">*/}
                        {/*        <div className="create-doc-set-bol-modal-add-new-field__new-input">*/}
                        {/*            <label>Label</label>*/}
                        {/*            <div className="create-doc-set-bol-modal-add-new-field__new-input-select">*/}
                        {/*                <Select placeholder='Text'/>*/}
                        {/*                <img className="create-doc-set-bol-modal-add-new-field__icon-show-more" src={showMoreBtnIcon} alt={'иконка показать больше'}/>*/}
                        {/*            </div>*/}
                        {/*        </div>*/}
                        {/*        <div className="create-doc-set-bol-modal-add-new-field__btn-add-new">*/}
                        {/*            <img src={addPlusIcon} alt={'иконка плюс'} />*/}
                        {/*            <p>Add new field</p>*/}
                        {/*        </div>*/}
                        {/*</div>*/}
                        <div className="create-doc-set-bol-modal-add-new-field">
                            <div className="create-doc-set-bol-modal-add-new-field__new-input">
                                <label>Cargo on board remark</label>
                                <div className="create-doc-set-bol-modal-add-new-field__new-input-select">
                                    <input className="create-doc-set-bol-modal__templates-input-text-description"
                                           type={'text'}
                                           name={'bolRemarks'}
                                           defaultValue={editDoc === true ? currentCargoCaseBol[0]?.bolRemarks : formik.values.name}
                                           onChange={formik.handleChange}
                                           onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.bolRemarks && formik.touched.bolRemarks ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.bolRemarks}</p> : null}
                                </div>
                            </div>
                            <div className="create-doc-set-bol-modal-add-new-field__new-input">
                                <label>Freight payment remark</label>
                                <div className="create-doc-set-bol-modal-add-new-field__new-input-select">
                                    <input className="create-doc-set-bol-modal__templates-input-text-description"
                                           type={'text'}
                                           name={'notify'}
                                           defaultValue={editDoc === true ? currentCargoCaseBol[0]?.notify : formik.values.name}
                                           onChange={formik.handleChange}
                                           onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.notify && formik.touched.notify ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.notify}</p> : null}
                                </div>
                            </div>
                            {/*<div className="create-doc-set-bol-modal-add-new-field__btn-add-new">*/}
                            {/*    <img src={addPlusIcon} alt={'иконка плюс'} />*/}
                            {/*    <p>Add new field</p>*/}
                            {/*</div>*/}
                        </div>
                        <div className="create-doc-set-bol-modal__optional">
                            <div className="create-doc-set-bol-modal__optional-open-row">
                                <p>Optional</p>
                                <img onClick={() => setActiveOpenOptional(!activeOpenOptional)}  src={activeOpenOptional ? rowUpIcon : rowDownIcon} alt={'иконка стрелочка'}/>
                            </div>
                            <div className={activeOpenOptional ? "create-doc-set-bol-modal__optional-content" : "create-doc-set-bol-modal__optional-content hide"}>
                                <div className="create-doc-set-bol-modal__optional-content-input">
                                    <label>Notify party</label>
                                    <textarea className="create-doc-set-bol-modal__optional-content-text-area"
                                              placeholder={'text'}
                                              name={'notifyParty'}
                                              defaultValue={editDoc === true ? currentCargoCaseBol[0]?.notifyParty : formik.values.name}
                                              onChange={formik.handleChange}
                                              onBlur={formik.handleBlur}
                                    />
                                    {formik.errors.notifyParty && formik.touched.notifyParty ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.notifyParty}</p> : null}
                                </div>
                                <div className="create-doc-set-bol-modal-add-new-field__new-input">
                                    <label>Carrier</label>
                                    <div className="create-doc-set-bol-modal-add-new-field__new-input-select">
                                        <input className="create-doc-set-bol-modal__templates-input-text-description"
                                            type={'text'}
                                            name={'carrier'}
                                            defaultValue={cargoCaseDocument[0]?.shipowner?.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            disabled={true}
                                        />
                                        {formik.errors.carrier && formik.touched.carrier ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.carrier}</p> : null}
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal-add-new-field__new-input">
                                    <label>Units of measurement</label>
                                    <div className="create-doc-set-bol-modal__optional-content-input">
                                        <textarea className="create-doc-set-bol-modal__optional-content-text-area"
                                            name={'unitsOfMeasurement'}
                                            defaultValue={editDoc === true ? currentCargoCaseBol[0]?.unitsOfMeasurement : formik.values.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.unitsOfMeasurement && formik.touched.unitsOfMeasurement ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.unitsOfMeasurement}</p> : null}
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal-add-new-field__new-input">
                                    <label>Character party dated</label>
                                    <div className="create-doc-set-bol-modal-add-new-field__new-input-select">
                                        <input className="create-doc-set-bol-modal__templates-input-text-description"
                                            type={'text'}
                                            name={'characterPartyDated'}
                                            defaultValue={editDoc === true ? currentCargoCaseBol[0]?.characterPartyDated : formik.values.name}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        {formik.errors.characterPartyDated && formik.touched.characterPartyDated ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.characterPartyDated}</p> : null}
                                    </div>
                                </div>
                                <div className="create-doc-set-bol-modal__templates-group-inputs">
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Reference No</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"text"}
                                       name={'referenceNo'}
                                       defaultValue={editDoc === true ? currentCargoCaseBol[0]?.referenceNo : formik.values.name}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                />
                                {formik.errors.referenceNo && formik.touched.referenceNo ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.referenceNo}</p> : null}
                            </div>
                            <div className="create-doc-set-bol-modal__templates-input">
                                <label>Code name</label>
                                <input className="create-doc-set-bol-modal__templates-input-text"
                                       type={"text"}
                                       name={'codeName'}
                                       defaultValue={editDoc === true ? currentCargoCaseBol[0]?.codeName : formik.values.name}
                                       onChange={formik.handleChange}
                                       onBlur={formik.handleBlur}
                                />
                                {formik.errors.codeName && formik.touched.codeName ? <p className="create-doc-set-loading-order-modal-form-error">{formik.errors.codeName}</p> : null}
                            </div>
                        </div>
                            </div>
                        </div>
                        <div className="create-doc-set-bol-modal__buttons">
                            <button onClick={closeModal} className="create-doc-set-bol-modal__buttons-cancel">Cancel</button>
                            <button type={"submit"} className="create-doc-set-bol-modal__buttons-save">Save</button>
                            <p className="create-doc-set-bol-modal__buttons-message-error">{errorMessage}</p>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}
export default CreateDocSetBolModal;